import React from 'react';

export const currency = (n) => `R ${Number(n || 0).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const STATUS_STYLES = {
  draft: 'bg-stone-100 text-stone-700 border-stone-200',
  sent: 'bg-blue-50 text-blue-800 border-blue-100',
  partial: 'bg-amber-50 text-amber-800 border-amber-200',
  paid: 'bg-emerald-50 text-emerald-800 border-emerald-100',
  cancelled: 'bg-red-50 text-red-800 border-red-100',
};

export const STATUS_LABELS = { draft: 'Draft', sent: 'Sent', partial: 'Part paid', paid: 'Paid', cancelled: 'Cancelled' };

export const StatusPill = ({ inv, testid }) => (
  <span className="inline-flex items-center gap-1.5" data-testid={testid}>
    <span className={`text-xs font-medium px-2 py-0.5 rounded-full border ${STATUS_STYLES[inv.status] || STATUS_STYLES.draft}`}>{STATUS_LABELS[inv.status] || inv.status}</span>
    {inv.overdue && <span className="text-[10px] font-bold uppercase tracking-wider text-red-700">Overdue</span>}
  </span>
);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
export const toDateInput = (iso) => (iso ? new Date(iso).toISOString().slice(0, 10) : '');
export const fromDateInput = (d) => (d ? new Date(`${d}T09:00:00Z`).toISOString() : null);
